module.exports = __webpack_public_path__ + "img/IMG_9206.5117cc19.jpg";